export default {
	service: [
		"Služba",
		"Udalosť",
		"Výber",
		"Vklad",
		"Podmienky",
		"Certifikát",
		"Časté otázky",
		"Užívateľská príručka",
		"VIP"
	],
	sign: {
		title: "Prihlásený pre {0} deň",
		SignIn: "Prihlásiť sa"
	},
	hotMusicAlbum: "Hot Music Album",
	hotMusic: "Horúce hudobné rebríčky",
	popular: "Nové prehrávanie",
	rankings: "Populárne filmy",
	top: "TOP{0}",
	OnchainServices: "Onchain služby",
	Real: {
		title: "V reálnom čase",
		list: [
			"Celkový počet online používateľov",
			"Priemerný objem optimalizácie používateľa",
			"Tepelná mapa potrieb optimalizácie",
			"Množstvo optimalizácie propagácie platformy"
		]
	},
	work: {
		title: "Odmena za odoslanie objednávky",
		SignIn: "Získať"
	},
	Profit: {
		Profit: "Zisk",
		tabs: ["Zisk", "Bonus", "Účet"],
		TotalBalance: "Celkový zostatok",
		TotalLuckyBonus: "Celkový Šťastný Bonus",
		todayEarnings: "Dnešné Zárobky",
		availableBalance: "Dostupný zostatok",
		title: ["Dnešné Zárobky", "Celkové Zárobky", "Účet"],
		list: ["Zárobky z Objednávok", "Zárobky Tímu", "Celkové Zárobky"],
		order: {
			title: "Zisk z Objednávky",
			commission: "Provizia z Objednávky"
		},
		Analysis: {
			title: "Analýza Ziskov",
			tips: "Vykonali ste {0} transakcií",
			tabs: ["Dnešný Zisk", "Celkový Zisk"],
			totalTitle: ["Zisk z Objednávky", "Zisk z Registrácie", "Zisk Tímu", "Zisk z Bonusu"]
		}
	},
	CustomerService: {
		title: "Centrum Zákazníckej Podpory",
		consultation: "Konzultácia Zákazníckeho Servisu",
		btn: "Kontaktujte nás",
		noticeTitle: "Systémové Oznámenie"
	},
	addWallet: "Pridať peňaženku",
	taskProgress: "Pokrok v denných úlohách",
	currentProgress: "Aktuálny postup úlohy",
	awardsBulletin: `{0} používateľ vyhráva {1} {2} cenu v úlohe.`,
	vip: {
		title: "@:vip.title",
		more: "Zobraziť viac"
	},
	stats: {
		title: "Zdroje údajov - Dashboard a API",
		subTitle: "Statistiky umelcov",
		list: ["Metriky", "Umelci s aktívnymi sociálnymi sítí", "Aktualizované denne"]
	}
};
